import React from 'react'
import styled from 'styled-components'

const StyledCardTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.medium} 0;
`

export const CardTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <StyledCardTitle>{children}</StyledCardTitle>
}
